import { Drawer } from "antd";
import { get, isEmpty } from "lodash";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useMediaQuery } from "react-responsive";
import Button from "shared/components/Button";
import Container from "shared/components/Container";
import { NAME_SPACES } from "shared/locales/constants";
import Stepper from "../Components/Stepper";
import Budget from "./Budget";
import Levels from "./Levels";
import Needs from "./Needs";
import { BsArrowLeftCircle } from "react-icons/bs";

function View({
  fields,
  onNext,
  onBack,
  categories,
  needsLevels,
  labels,
  categoriesConfig,
  locked,
}) {
  const { t } = useTranslation(NAME_SPACES.PUBLIC.PROCESSES);
  const TRANSLATION = t("DETAIL", { returnObjects: true });

  const [drawerVisible, setDrawerVisible] = useState(false);
  const [budget, setBudget] = useState(
    get(fields, "budget.max")
      ? { min: get(fields, "budget.min"), max: get(fields, "budget.max") }
      : {},
  );
  const [selectedValues, setSelectedValues] = useState(
    categories.reduce((acc, category) => {
      acc[category.value] = get(fields, `needs.${category.value}`, 1);
      return acc;
    }, {}),
  );
  const isMobile = useMediaQuery({ maxWidth: 768 });

  const handleSubmit = () => {
    onNext({
      payload: {
        fields: {
          ...fields,
          budget,
          needs: selectedValues,
        },
      },
    });
  };

  return (
    <Container size="medium">
      <div className="b2c__area">
        <Stepper
          items={[
            { label: TRANSLATION.STTEPER.SITUATION, completed: true },
            { label: TRANSLATION.STTEPER.QUOTE, completed: false },
            { label: TRANSLATION.STTEPER.SUBSCRIPTION, completed: false },
            { label: TRANSLATION.STTEPER.VALIDATION, completed: false },
          ]}
        />
        <div className="b2c__area--header">
          <div className="b2c__area--header__title">
            {TRANSLATION.NEEDS.TITLE_START}{" "}
            <span>{TRANSLATION.NEEDS.TITLE_HIGHLIGHT}</span>{" "}
            {TRANSLATION.NEEDS.TITLE_END}
          </div>
        </div>
        <div className="b2c__area--content b2c__needs">
          <Needs
            categories={categories}
            selectedValues={selectedValues}
            setSelectedValues={setSelectedValues}
            onClick={() => setDrawerVisible(true)}
            needsLevels={needsLevels}
            labels={labels}
            categoriesConfig={categoriesConfig}
            disabled={locked}
            translation={TRANSLATION}
          />
          {/* <Budget
            value={
              budget?.max && !(budget.min === 0 && budget.max === 1000)
                ? `${budget.min}-${budget.max}`
                : null
            }
            options={[
              {
                value: "0-50",
                label: TRANSLATION.NEEDS.BUDGET.OPTIONS.RANGE_0_50,
              },
              {
                value: "50-100",
                label: TRANSLATION.NEEDS.BUDGET.OPTIONS.RANGE_50_100,
              },
              {
                value: "100-200",
                label: TRANSLATION.NEEDS.BUDGET.OPTIONS.RANGE_100_200,
              },
              {
                value: "200-500",
                label: TRANSLATION.NEEDS.BUDGET.OPTIONS.RANGE_200_500,
              },
              {
                value: "500-1000",
                label: TRANSLATION.NEEDS.BUDGET.OPTIONS.RANGE_500_1000,
              },
              {
                value: "1000-9999",
                label: TRANSLATION.NEEDS.BUDGET.OPTIONS.RANGE_1000_PLUS,
              },
            ]}
            onChange={(e) => {
              const [min, max] = e.split("-");
              setBudget({ min: parseInt(min), max: parseInt(max) });
            }}
            onClear={() => setBudget({ min: 0, max: 1000 })}
            disabled={locked}
            translation={TRANSLATION}
          /> */}
        </div>
        <div className="b2c__area--actions">
          <Button onClick={onBack} className="prev">
            <BsArrowLeftCircle size={32} />
            <span>{TRANSLATION.PREVIOUS}</span>
          </Button>
          <Button
            shape={true}
            className="b2c__area--actions__next"
            onClick={handleSubmit}
            disabled={isEmpty(selectedValues)}
          >
            {TRANSLATION.NEXT}
          </Button>
        </div>
      </div>

      <Drawer
        placement="right"
        className="b2c__drawer right--drawer"
        closable
        onClose={() => setDrawerVisible(false)}
        open={drawerVisible}
        width={isMobile ? "98%" : "50%"}
      >
        <div className="drawer__wrapper">
          <div className="drawer__wrapper--header">
            <div className="title">
              <h3>{TRANSLATION.NEEDS.DRAWER.TITLE}</h3>
            </div>
            <p>{TRANSLATION.NEEDS.DRAWER.DESCRIPTION}</p>
          </div>
          <Levels
            needsLevels={needsLevels}
            labels={labels}
            translation={TRANSLATION}
          />
          <Button
            type="secondary"
            onClick={() => {
              setDrawerVisible(false);
            }}
          >
            {TRANSLATION.NEEDS.DRAWER.CLOSE}
          </Button>
        </div>
      </Drawer>
    </Container>
  );
}

export default View;
